const o = {
  color: {
    selection: "#d1e8ffff",
    boxShadow: "#abb9c7ff"
  }
};
export {
  o as copyCode
};
